module.exports = __webpack_public_path__ + "static/media/twitter.bd81acc4.svg";